interface ZohoDeskInvoke {
  invoke: (action: string, payload?: Record<string, unknown>) => unknown;
}

function getZohoDesk(): ZohoDeskInvoke | undefined {
  return (globalThis as unknown as { ZOHODESK?: ZohoDeskInvoke }).ZOHODESK;
}

export function popContact(contactId: string): void {
  getZohoDesk()?.invoke('ROUTE_TO', { entity: 'contact', id: contactId });
}

export function popTicket(ticketId: string): void {
  getZohoDesk()?.invoke('ROUTE_TO', { entity: 'ticket', id: ticketId });
}

export function showWidget(): void {
  getZohoDesk()?.invoke('SHOW');
}

export function hideWidget(): void {
  getZohoDesk()?.invoke('HIDE');
}

export function maximizeWidget(): void {
  getZohoDesk()?.invoke('MAXIMIZE');
}

export function minimizeWidget(): void {
  getZohoDesk()?.invoke('MINIMIZE');
}
